module.exports = __webpack_public_path__ + "static/media/hide_icon.f209b2f8.svg";